<template>
  <div class="row">
    <div class="col-12">
      <template>
        <component
          :is="component"
          :eduInfo.sync="eduInfo"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'education-division5',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
        }
      },
    },
  },
  data() {
    return {
      editable: true,
      eduInfo: {
        educationKindCdLarge: 'EKFC000001', // process menaul
      },
      component: null,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.component = () => import('@/pages/sop/edu/annualEducationTrendAnalysisGraph.vue');
      this.getList();
    },
    getList() {
    },
  }
};
</script>